import { Classes, Overlay } from '@blueprintjs/core';
import React from 'react';
import toastr from 'toastr';
import Form from '../../components/common/Form';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import countriesDialCodes from '../common/countriesDialCodes.json';

class DeleteSubscribersModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            overlayIsOpen: false,
            done: false,
            data: {
                deleteSubscriberIds: this.props.deleteSubscribersIds,
                deleteSubscribersPageSize: this.props.pageSize,
                deleteSubscribersPage: this.props.currentPage,
                deleteSubscribersType: this.props.deleteSubscribersType
            },
            errors: {},
            spinnerActive: false
        };
    }

    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    doSubmit = async (e) => {
        this.setState({spinnerActive: true})
        let selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked || this.state.selected_source);
        // this.props.acceptModal(e, data);
        try {
            //  console.log(data.tagId)
            //     console.log('net tag name:', data.new_tag)
            //console.log('delete subscriber ids: ', this.state.deleteSubscribersIds);
            let response = await http.delete('api/feed/' + selected_source + '/subscribers/' + this.props.subscribersType +
                '/page_size/' + this.props.pageSize + '?page=' + this.props.currentPage,
                {
                    headers: {authorization: getJwt()},
                    data: {subscriber_ids: this.props.deleteSubscriberIds}

                });
            //console.log('delete subscribers response:', response);

            toastr.success('Subscribers successfully deleted.');
            this.setState({spinnerActive: false})

            let indicator = '';
            if (this.state.deleteSubscribersIndicator === 0) {
                indicator = 1
            } else {
                indicator = 0
            }
            await this.props.setDeleteSubscribersIndicator(indicator)
            await this.props.handleClose();
            await this.props.updateUserFromServer();
            // await this.setState(
            //     {deleteSubscribersIndicator: indicator}
            // );

        } catch (ex) {

            toastr.error("Error Code #10014: Subscribers couldn't be deleted");

            let indicator = '';
            if (this.state.deleteSubscribersIndicator === 0) {
                indicator = 1
            } else {
                indicator = 0
            }
            this.setState({spinnerActive: false})
            await this.props.setDeleteSubscribersIndicator(indicator)
            // await this.setState(
            //     {deleteSubscriberIndicator: indicator}
            // );
        }
    };

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }


    render() {
        let {visible_modal, onClickAway} = this.props;

        return (
            <Overlay
                onClose={() => {
                    this.handleClose()
                    this.props.handleClose()
                }}
                className={Classes.OVERLAY_SCROLL_CONTAINER + ' z-index-20'} isOpen={this.state.overlayIsOpen}
                autoFocus={true}
                canEscapeKeyClose
                canOutsideClickClose={true}
                enforceFocus={true}
                hasBackdrop={true}
                usePortal={true}
                transitionDuration={100}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >

                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        {/*{console.log('tag_id', this.state.data.tagId)}*/}
                        {/*{console.log('tag_name', this.state.data.tagName)}*/}
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Delete Subscribers</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>

                                <span className="">Are you sure you want to delete selected subscribers?</span>
                            </div>
                            <div className='justify-content-end flex-direction-row margin-bottom-20'>
                                <button disabled={false}
                                        onClick={this.props.handleClose}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className="btn-white-border margin-right-10"
                                >
                                    Cancel
                                </button>
                                {!this.state.spinnerActive ?
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger">Delete</button>
                                    :
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            className="btn-danger btn-spinner">Delete <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default DeleteSubscribersModal;